<script>
import Popin from "@/components/molecules/popin";
import WidgetPlanningTabTraiteur from "@/components/organisms/widget-planning/widget-planning-tab/traiteur";

export default {
  name: "PopinClickCollectTraiteurPermanent",
  components: {
    Popin,
    WidgetPlanningTabTraiteur
  },
  methods: {
    show() {
      this.$refs.popin.show();
    }
  },
  props: {
    magasin: {
      type: Object,
      required: false,
      default: () => []
    }
  },
  computed: {
    clickAndCollectTraiteurService() {
      const mdcClickAndCollect =
        this.magasin.attributes.modes_commande &&
        this.magasin.attributes.modes_commande.find(
          (e) => e.type === "CC_TRAITEUR_PERMANENT"
        );
      return mdcClickAndCollect ? mdcClickAndCollect.services[0] : {};
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    size="lg"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    aria-label="Planning traiteur"
  >
    <WidgetPlanningTabTraiteur
      v-if="magasin.attributes"
      class="u-pl-md u-pr-md u-pb-md u-p-none@sm"
      :magasin-name="magasin.attributes.magasin"
      :service="clickAndCollectTraiteurService"
    />
  </Popin>
</template>

<style lang="scss" scoped>
</style>
